import ManageAccount from './ManageAccount';

export default ManageAccount;
